import styled from 'styled-components';

/**
 * Écran affiché quand on n'a pas pu joindre l'API au démarrage : la session est peut-être
 * parfaitement valide, on n'en sait rien. Surtout ne pas afficher l'écran de connexion, qui
 * ferait croire à une déconnexion et pousserait à ressaisir des identifiants pour rien.
 */
export function ServerUnreachable({ onRetry }: { onRetry: () => void }) {
    return (
        <Container>
            <Title>Serveur injoignable</Title>
            <Message>
                Impossible de contacter l&apos;API. Votre session est conservée : réessayez dès que la connexion est
                rétablie.
            </Message>
            <RetryButton onClick={onRetry} data-test="server-unreachable-retry">
                Réessayer
            </RetryButton>
        </Container>
    );
}

const Container = styled.div`
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    height: 100vh;
    padding: 30px;
    background-color: ${({ theme }) => theme.backgroundColor};
`;

const Title = styled.span`
    font-size: 42px;
    font-weight: 800;
    color: ${({ theme }) => theme.textColor};
`;

const Message = styled.span`
    margin-top: 12px;
    max-width: 480px;
    text-align: center;
    font-size: 16px;
    color: ${({ theme }) => theme.infoTextColor};
`;

const RetryButton = styled.button`
    margin-top: 24px;
    padding: 12px 32px;
    font-size: 16px;
    font-weight: 600;
    color: white;
    background-color: ${({ theme }) => theme.ctaPrimaryColor};
    border: none;
    border-radius: 8px;
    cursor: pointer;
    transition: opacity 0.2s;

    &:hover {
        opacity: 0.85;
    }
`;
